import React, {useEffect} from "react"
import {formatTextTestIds} from "@next/utils"
import {breakpoints} from "@next/themes"
import Backdrop from "@mui/material/Backdrop"
import Fade from "@mui/material/Fade"
import {TextModel} from "models/Text"

import connect from "./connect"
import FacetsButton from "../facetsButton"
import CharacterFilter from "../characterFilter"
import SelectedFacets from "../selectedFacets"
import FacetsGrid from "../facetsGrid"
import FacetSearch from "../facetSearch"
import {
    ModalAppBar,
    ModalToolbar,
    StyledModal,
    ModalBody,
    ModalTitle,
    FiltersBody,
    FiltersReview,
    ConfirmCTAOuterWrapper,
    StyledCTA,
} from "./components"
import {getPortalEntrypoint} from "../../utils/getPortalEntrypoint"
import {useIsOnClient} from "../../hooks/useIsOnClient"
import useMediaQuery from "../../hooks/useMediaQuery"

interface ViewAllModalProps {
    isViewMoreOpen: boolean
    title: string
    hideSearchBox: boolean
    hideLetterNav: boolean
    onClose: (event: React.MouseEvent<HTMLButtonElement>) => void
    onCloseResize: () => void
    onCloseApplyFilter: () => void
    text: TextModel
}

export const ViewAllModal = ({
    isViewMoreOpen,
    onClose,
    onCloseResize,
    title,
    onCloseApplyFilter,
    hideSearchBox,
    hideLetterNav,
    text,
}: ViewAllModalProps) => {
    const {isOnClient} = useIsOnClient()
    const isMedium = useMediaQuery(`(min-width: ${breakpoints.values.lg}px)`)

    useEffect(() => {
        if (!isMedium) {
            onCloseResize()
        }
    }, [onCloseResize, isMedium])

    if (!isOnClient) {
        return null
    }

    return (
        <StyledModal
            disableScrollLock
            aria-labelledby="plp-modal-title"
            aria-describedby="plp-modal-description"
            aria-modal="true"
            data-testid={formatTextTestIds("plp-view-all-modal")}
            open={isViewMoreOpen}
            className="platform_modernisation_plp"
            onClose={onClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
            role="dialog"
            container={getPortalEntrypoint()}
        >
            <Fade in={isViewMoreOpen}>
                <ModalBody>
                    <ModalAppBar>
                        <ModalToolbar variant="dense" disableGutters>
                            <ModalTitle variant="h4" component="h1" id="plp-modal-title">
                                {title}
                            </ModalTitle>
                            {!hideSearchBox && <FacetSearch />}
                            <FacetsButton
                                onClick={onClose}
                                text={text.buttons.close}
                                data-testid="plp-view-all-close"
                            />
                        </ModalToolbar>
                    </ModalAppBar>
                    {!hideLetterNav && <CharacterFilter />}
                    <FiltersBody>
                        <FacetsGrid />
                        <FiltersReview>
                            <SelectedFacets />
                            <ConfirmCTAOuterWrapper>
                                <div data-testid="plp-view-all-confirm">
                                    <StyledCTA onClick={onCloseApplyFilter}>{text.buttons.confirm}</StyledCTA>
                                </div>
                            </ConfirmCTAOuterWrapper>
                        </FiltersReview>
                    </FiltersBody>
                </ModalBody>
            </Fade>
        </StyledModal>
    )
}

export default connect(ViewAllModal)
